import script from "./SkillCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillCards.vue?vue&type=script&setup=true&lang=ts"

import "./SkillCards.vue?vue&type=style&index=0&id=6efe644e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6efe644e"]])

export default __exports__